export default "__VITE_PUBLIC_ASSET__f794062d__"